import React, { useEffect, createElement } from 'react';
import { ContactHero } from './contact/ContactHero';
import { ContactQuickCards } from './contact/ContactQuickCards';
import { ContactFormHeader } from './contact/ContactFormHeader';
import { ContactFormForm } from './contact/ContactFormForm';
import { ContactFormDetails } from './contact/ContactFormDetails';
import { ContactMap } from './contact/ContactMap';
import { ContactRelatedLinks } from './contact/ContactRelatedLinks';
export function Contact() {
  useEffect(() => {
    document.title = 'Contact Storm Taekwondo | Farmington Hills, MI';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Contact Storm Taekwondo in Farmington Hills. Call 517-220-0621, email info@stormtaekwondo.com, or send us a message about classes, programs, summer camp, billing, or anything else.';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-828">
      <ContactHero data-id="element-829" />
      <ContactQuickCards data-id="element-830" />
      <section className="py-24 bg-off-white" data-id="element-831">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-832">
          <div className="grid lg:grid-cols-5 gap-12 items-start" data-id="element-833">
            {/* Left: form */}
            <div className="lg:col-span-3" data-id="element-834">
              <ContactFormHeader data-id="element-835" />
              <ContactFormForm data-id="element-836" />
            </div>
            {/* Right: details */}
            <ContactFormDetails data-id="element-837" />
          </div>
        </div>
      </section>
      <ContactMap data-id="element-838" />
      <ContactRelatedLinks data-id="element-839" />
    </div>;
}